module.exports = __webpack_public_path__ + "static/media/YM53_2.ecd94fbd.jpg";